

    <div  #myModalVoucher class="modal fade" data-backdrop="static" data-keyboard="false" id="modal-sm">
      <div class="modal-dialog" >
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">www.andreagt.com</h4>
            
          </div>

         
          
          
         
          <div class="modal-body">
            <blockquote class="quote-info" style="text-align: center;">
            <h5 id="note">¡Anulación Realizada!</h5>
            

          

            </blockquote>
          </div>
     

    

          <div class="modal-body" style="text-align: center;">
            <img src="./assets/dist/img/neonet.jpg" width="25%"   style="opacity: .9"> 
            <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{nombreEmpresaDTO}}</h6>
            <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{direccionEmpresaDTO}}</h6>
            <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">Guatemala C.A.  {{fechaPedidoDTO | date:'dd/MM/yyyy'}} {{horaPedidoDTO }}    No.{{sysTraceNo}}</h6>
            <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">REF {{retrievalResponseDTO}} AUT {{authResponseDTO}}</h6>
            <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">No. TARJETA {{noTarjetaDTO}} EXP: XX/XX</h6>
            <br>
            <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">COMPRA: <strong>  (-) {{granTotalDTO | currency: 'Q'}} </strong></p> 
            <br>
            <h6 style="color: black; font-size: 14PX; font-family:'Courier New', Courier, monospace">(01) PAGADO ELECTRONICAMENTE !!</h6>
          </div>

     

        
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-info" (click)="OnContinuar()" >Continuar</button>
          
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>











<div   #myModal3 class="modal fade" id="modal-lg">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Envio</h4>
        <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      
        <form [formGroup]="formEnvio">
       
      
        <div class="row">

          
          <div class="form-group">
        
            <table class="table table-bordered">
              <thead>
                <tr >
                  
                  <th>Cantidad</th>
                  <th>Modelo</th>
                  <th >Color</th>
                  <th >Talla</th>
                  <th ></th>
               
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dato of detallePedidoApartarDTO; let i=index" >
                 
                  <td>{{dato.cantidad}}</td>
                  <td>{{dato.modelo}}</td>
                  <td >{{dato.colorErp}}</td>
                  <td >{{dato.talla}}</td>
                  <td  style="text-align: center;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;"></td>
                
                
                 
                </tr>
                
               
              </tbody>
            </table>
          </div>
      

       

        <div class="form-group">
          <label for="label1">No. Guía / Envío</label>
          
          <input type="text" class="form-control"  placeholder=" " formControlName="txtNumeroGuia" [maxLength]="30" autocomplete="false">
        </div>
        <div *ngIf="errorForm[1] == '1'">
          <label for="label1"><code>Debe escribir un número de guia</code></label>
        </div>

      </div>

    </form>

      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-warning" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-warning" (click)="OnRegistrarEnvio()">Registar Envío</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->


<div   #myModal2 class="modal fade" id="modal-lg">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Cambio</h4>
        <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      

       
       
        <div class="row">

          
          <div class="form-group">
            <label for="label1">Artículo anterior</label>
            <table class="table table-bordered">
              <thead>
                <tr >
                  
                  <th>Cantidad</th>
                  <th>Modelo</th>
                  <th >Color</th>
                  <th >Talla</th>
                  <th ></th>
                
               
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dato of detallePedidoApartarDTO; let i=index" >
                 
                  <td>{{dato.cantidad}}</td>
                  <td>{{dato.modelo}}</td>
                  <td >{{dato.colorErp}}</td>
                  <td >{{dato.talla}}</td>
                  <td  style="text-align: center;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;"></td>
                
                 
                </tr>
                
               
              </tbody>
            </table>
          </div>
      
          <div *ngFor="let dato of detalleCambioDTO; let i=index">
           
         
          <div class="form-group">
            <div class="callout callout-danger">
              <h5>No. Ticket de Cambio:</h5>
              <h5 class="text-danger">{{this.idCambioDTO}} </h5>

             
            </div>
          </div>
        
          <div class="form-group">
            <div class="callout callout-danger">
              <h5>Motivo del cambio:</h5> 
              {{dato.motivo}}
              <p></p>
            </div>
          </div>


        <div class="form-group">
          <label for="label1">Artículo de cambio.</label>
          <table class="table table-bordered">
            <thead>
              <tr >
                
                <th>Cantidad</th>
                <th>Modelo</th>
                <th>Color</th>
                <th>Talla</th>
                <th></th>
              
             
              </tr>
            </thead>
            <tbody>
          
                <tr >
                 
                  <td >{{dato.cantidad}}</td>
                  <td>{{dato.modelo}}</td>
                  <td>{{dato.colorErp}}</td>
                  <td>{{dato.talla}}</td>
                  <td   style="text-align: center;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;"></td>
                
                </tr>
                
               
            
            </tbody>
          </table>
 
    </div>


    
    <div class="form-group">
        
      <table class="table table-bordered">
        <thead>
          <tr >
            
            <th>Sucursal</th>
            <th>Existencia</th>
            <th>Color</th>
            <th>Cod. ERP</th>
            <th></th>
         
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dato of stockERPDTO; let i=index">
           
            <td >{{dato.almacen}}</td>
            <td>{{dato.existencia}}</td>
            <td>{{dato.color}}</td>
            <td>{{dato.codigoErp}}</td>
            <td>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="radio" (change)="OnSeleccionarStockERP(dato.almacenId,dato.codigoErp,dato.color)" >
              <label class="form-check-label"></label>
            </div>
          </td>
          </tr>
          
         
        </tbody>
      </table>

</div>

<form [formGroup]="formCambio">
<div class="form-group">
  <label for="label1">Observación</label>
  <textarea class="form-control"  placeholder="Escriba alguna observacion"  formControlName="txtObservacion2"></textarea>

 
</div >
</form>


  </div>

         

      </div>



      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-danger" (click)="OnCambiarPedido()">Aplicar Cambio</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->


<div   #myModal class="modal fade" id="modal-lg">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Apartar</h4>
        <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      

       
        <form [formGroup]="formApartado">
        <div class="row">

          
          <div class="form-group">
        
            <table class="table table-bordered">
              <thead>
                <tr >
                  
                  <th>Cantidad</th>
                  <th>Modelo</th>
                  <th >Color</th>
                  <th >Talla</th>
                  <th ></th>
               
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dato of detallePedidoApartarDTO; let i=index" >
                 
                  <td>{{dato.cantidad}}</td>
                  <td>{{dato.modelo}}</td>
                  <td >{{dato.colorErp}}</td>
                  <td >{{dato.talla}}</td>
                  <td  style="text-align: center;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;"></td>
                 
                </tr>
                
               
              </tbody>
            </table>
          </div>



        <div class="form-group">
        
          <table class="table table-bordered">
            <thead>
              <tr >
                
                <th>Sucursal</th>
                <th>Existencia</th>
                <th>Color</th>
                <th>Cod. ERP</th>
                <th></th>
             
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dato of stockERPDTO; let i=index">
               
                <td >{{dato.almacen}}</td>
                <td>{{dato.existencia}}</td>
                <td>{{dato.color}}</td>
                <td>{{dato.codigoErp}}</td>
                <td>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="radio" (change)="OnSeleccionarStockERP(dato.almacenId,dato.codigoErp,dato.color)" >
                  <label class="form-check-label"></label>
                </div>
              </td>
              </tr>
              
             
            </tbody>
          </table>
 
    </div>



         


        <div class="form-group">
          <label for="label1">Observación</label>
          <textarea class="form-control"  placeholder="Escriba alguna observacion"  formControlName="txtObservacion"></textarea>
        
         
        </div >
        <div *ngIf="errorForm[1] == '1'">
          <label for="label1"><code>Debe indicar una observación</code></label>
        </div>

      </div>
    </form>


      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="OnApartarPedido()">Apartar atículo</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<section class="content">
    <div class="container-fluid">
      <div class="row">
        <!-- left column -->
        <div class="col-md-10">

<div class="card card-warning">
    <div class="card-header">
      <h3 class="card-title">Detalle de Pedido</h3>
    </div>
    
    <div class="card-body">

      <div *ngFor="let dato of pedidoDTO; let i=index">
        <p>No. Pedido: <code style="font-size: 16px;color:darkblue;"> {{dato.idPedido}}</code></p>
        <p>Fecha: <code style="font-size: 16px;color: darkblue;"> {{dato.fecha}}</code></p>
        <p>Cliente: <code style="font-size: 16px;color: darkblue;"> {{dato.cliente}}</code></p>
        <p>Lugar entrega: <code style="font-size: 16px;color: darkblue;"> {{dato.departamento}}</code> ,<code style="font-size: 16px;color: darkblue;"> {{dato.municipio}}</code></p>
        <p>Dirección de entrega: <code style="font-size: 16px;color: darkblue;"> {{dato.direccionEntrega}}</code></p>
        <p>Teléfono contacto: <code style="font-size: 16px;color: darkblue;">  {{dato.telefono}}</code></p>
        <p>Receptor: <code style="font-size: 16px;color: darkblue;"> {{dato.nombreRecibe}}</code></p>
        <p>Teléfono para enviar Factura: <code style="font-size: 16px;color: darkblue;"> {{dato.telefonoFactura}}</code></p>
        <p>Forma pago: <code style="font-size: 16px;color: darkblue;"> {{dato.formaPago}}</code></p>
        <!-- <p>Tajeta: <code style="font-size: 16px;color: darkblue;"> {{dato.numeroTarjeta}}</code> </p>
        <p>Ref: <code style="font-size: 16px;color: darkblue;"> {{dato.retrievalRefNo}}</code> </p>
        <p>Auth: <code style="font-size: 16px;color: darkblue;"> {{dato.authIdResponse}}</code> </p>
        <p>AUD: <code style="font-size: 16px;color: darkblue;"> {{dato.systemTraceno}}</code> </p> -->

        


      </div>

 <div class="card-body table-responsive p-0" style="height: 150px;">
      <table class="table table-head-fixed text-nowrap">
        <thead>
          <tr >
            <th>Tipo Transacción</th>
            <th>Tarjeta</th>
            <th>No.</th>
            <th >REF</th>
            <th >AUT</th>
            <th >Valor</th>
            <th >Estado</th>
            <th >Anular</th>
          </tr>
        </thead>
        <tbody>
          <tr  *ngFor="let dato of transaccionElectronicaDTO; let i=index">
            <td>{{dato.tipoTransaccion}}</td>
            <td>{{dato.tarjeta}}</td>
            <td> {{dato.systemTraceno}}</td>
            <td >{{dato.retrievalRefNo}}</td>
            <td >{{dato.authIdResponse}}</td>
            <td  >{{dato.total  | currency: 'Q'}}</td>
            <td  >{{dato.estado}}</td>
            <td  ><a class="btn btn-danger btn-sm" (click)="OnAnularPago(
              dato.idTipoTransaccion,
              dato.idPedido,
              dato.idEstado,
              dato.systemTraceno,
              dato.total,
              dato.idTransaccion)">Anular pago</a></td>
           
          </tr>
          
         
        </tbody>
      </table>
      </div>

      <div class="card-body table-responsive p-0" style="height: 300px;">
        <table class="table table-head-fixed text-nowrap">
          <thead>
            <tr >
              
              <th>Cantidad</th>
              <th>Modelo</th>
              <th >Color</th>
              <th style="text-align: center;" >Talla</th>
              <th ></th>
              <th >Estado</th>
           
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dato of detallePedidoDTO; let i=index" >
             
              <td style="text-align: center;">{{dato.cantidad}}</td>
              <td>{{dato.modelo}}</td>
              <td >{{dato.colorErp}}</td>
              <td style="text-align: center;">{{dato.talla}}</td>
              <td  style="text-align: center;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;" ></td>
              <td>{{dato.estado}}</td>
              <td><a class="btn btn-primary btn-sm" (click)="OnApartar(dato.idEstado,dato.indice,dato.idProducto,dato.cantidad,dato.modelo,dato.nMx,dato.colorIdErp,dato.codigoErp)" >Apartar</a></td>
              <td><a class="btn btn-danger btn-sm" (click)="OnCambio(dato.indice,dato.idProducto,dato.idPedido,dato.idEstado,dato.modelo,dato.nMx,dato.colorIdErp,dato.codigoErp)">Cambiar</a></td>
              <td><a class="btn btn-warning btn-sm" (click)="OnEnviado(dato.idPedido,dato.indice,dato.idProducto,dato.idEstado,dato.codigoErp,dato.colorIdErp)">Enviar</a></td>
            </tr>
            
           
          </tbody>
        </table>
        <div class="card-footer" style="text-align: center;">
   
          <button type="button" class="btn btn-warning" (click)="OnVerificarEstadoPedido()">Finalizar Pedido</button>
          
        </div>
      </div>
     
    


    </div>
   
  
  </div>


  




</div>
</div>
</div>
</section>

